import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";

export default function PhotoViewer({ photos, index, onIndex }) {
  const open = index !== null;
  const p = open ? photos[index] : null;
  const step = (d) => onIndex((index + d + photos.length) % photos.length);
  const btn = "absolute top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition-colors";
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onIndex(null); }}>
      <DialogContent className="max-w-[96vw] w-auto p-0 bg-transparent border-0 shadow-none [&>button:last-child]:hidden"
        onKeyDown={(e) => { if (e.key === "ArrowRight") step(1); if (e.key === "ArrowLeft") step(-1); }}
        data-testid="fleet-photo-viewer">
        <DialogTitle className="sr-only">{p?.alt}</DialogTitle>
        <DialogDescription className="sr-only">Photo {index + 1} of {photos.length}</DialogDescription>
        {p && (
          <div className="relative">
            <img src={p.src} alt={p.alt} className="max-w-[96vw] max-h-[88vh] object-contain rounded-xl select-none" data-testid="fleet-photo-viewer-img" />
            <DialogClose className="absolute top-2 right-2 w-11 h-11 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center" aria-label="Close" data-testid="fleet-photo-viewer-close">
              <X size={20} />
            </DialogClose>
            {photos.length > 1 && (
              <>
                <button onClick={() => step(-1)} className={`${btn} left-2`} aria-label="Previous photo" data-testid="fleet-photo-viewer-prev"><ChevronLeft size={22} /></button>
                <button onClick={() => step(1)} className={`${btn} right-2`} aria-label="Next photo" data-testid="fleet-photo-viewer-next"><ChevronRight size={22} /></button>
              </>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
